"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var RenderWhen = function RenderWhen(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 1 : _ref$limit,
    _ref$isTrue = _ref.isTrue,
    isTrue = _ref$isTrue === void 0 ? true : _ref$isTrue,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var childrenList = (0, _react.useMemo)(function () {
    if (!isTrue) {
      return null;
    }
    var list = [];
    _react.default.Children.map(children, function (child) {
      var _ref2 = (child === null || child === void 0 ? void 0 : child.props) || {},
        isChildTrue = _ref2.isTrue;
      if (isChildTrue === true && list.length < limit) {
        list.push(child);
      }
    });
    return list;
  }, [children, isTrue, limit]);
  return childrenList;
};
RenderWhen.propTypes = {
  children: _propTypes.default.any.isRequired,
  isTrue: _propTypes.default.bool,
  limit: _propTypes.default.number
};
var If = function If(_ref3) {
  var children = _ref3.children;
  return children;
};
If.displayName = 'If';
RenderWhen.If = If;
var _default = exports.default = RenderWhen;